import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
interface Props {
  isClickable?: boolean;
  isSelected?: boolean;
}

export const BillingProfileStyles = styled.div<Props>`
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
  border: ${(props) =>
    props.isSelected ? `2px solid ${token('color.border.selected')}` : `1px solid ${token('color.border')}`};
  border-radius: ${token('space.100')};
  padding: ${token('space.150')};
  gap: ${token('space.300')};
  display: flex;
  align-items: center;

  .billing-profile-info {
    display: flex;
    flex-direction: column;
    width: 100%;

    .billing-profile-header {
      display: flex;
      gap: ${token('space.100')};

      .billing-profile-info-title {
        flex: 2;
        color: ${(props) => (props.isClickable ? token('color.text') : token('color.text.disabled'))};
        font-weight: ${token('font.weight.semibold')};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .billing-profile-contact-info {
        display: flex;
        align-items: flex-start;
      }
    }

    .billing-profile-price-eligibility,
    .billing-profile-info-ship-to-party {
      font-size: 12px;
      color: ${(props) => (props.isClickable ? token('color.text.subtle') : token('color.text.disabled'))};
    }

    .billing-profile-info-payment {
      margin-top: ${token('space.150')};

      > div {
        padding: 0;
        border: none;
        > div {
          > div {
            gap: 0;
            > div:nth-child(1) {
              flex: none;
              svg {
                height: 16px !important;
                width: 24px !important;
              }
            }
            > div:nth-child(2) {
              display: flex;
              div {
                font: ${token('font.body.small')};
                color: ${(props) => (props.isClickable ? token('color.text') : token('color.text.disabled'))};
              }
              p {
                border-left: 1px solid ${token('color.border.accent.gray')};
                padding-inline-start: ${token('space.150')};
                margin: 0;
                font: ${token('font.body.small')};
                color: ${(props) => (props.isClickable ? token('color.text') : token('color.text.disabled'))};
              }
            }
          }
        }
      }

      .billing-profile-no-payment-method {
        font-size: 12px;
        font-weight: ${token('font.weight.regular')};
        color: ${(props) => (props.isClickable ? token('color.text.subtle') : token('color.text.disabled'))};
      }
    }

    .billing-profile-info-ship-to-party {
      margin-top: ${token('space.150')};
    }

    .billing-profile-disable-reason {
      margin-top: ${token('space.150')};
      font-size: 12px;
      color: ${token('color.text.danger')};
    }
  }
`;
